import { Alert, AlertTitle, Box } from "@mui/material";
import type { DataImportInfo } from "../../../../../api/types/dataImportTypes";

interface Props {
  dataImport: DataImportInfo;
  readOnly?: boolean;
  onClose: () => void;
}

const GeneralImportErrorsAlert = ({ dataImport, readOnly, onClose }: Props) => {
  const generalErrors = dataImport.validationResult?.generalErrors ?? [];

  if (generalErrors.length === 0) {
    return null;
  }

  return (
    <Box sx={{ pt: 2.5, px: 3 }}>
      <Alert severity="error" onClose={onClose}>
        {generalErrors.filter(Boolean).map((errorText, index) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <AlertTitle key={index}>{errorText}</AlertTitle>
        ))}
        {!readOnly && "Please fix the issues and run validation once again"}
      </Alert>
    </Box>
  );
};

export default GeneralImportErrorsAlert;
